import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  TextInput,
  Text,
  ActivityIndicator,
  TouchableOpacity,
  Modal,
  Animated,
} from "react-native";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
  Box,
} from "@mui/material";
import { ArrowBack, Search as SearchIcon } from "@mui/icons-material";
import { translateText } from "../../translations/translationService";
import { styles } from "../../style/FoundryStyle.js";
import { SCREEN_IDS } from "../FullComponent.js";
import { typeConnect, esFornitura } from "../../constants/Constants.js";
import { 
  BRAND_COLORS, 
  BACKGROUND_COLORS, 
  TEXT_COLORS, 
  BORDER_COLORS, 
  STATUS_COLORS, 
  SHADOW_COLORS,
  COMPONENT_COLORS,
  TABLE_COLORS 
} from "../../style/colors.js";
import ConsultaPiezasTabla from "./ComponentConsultaPiezasTabla.js";
import {
  fullDataRelevant,
  fullDataPiece,
  getDetalleDatosMos,
  fullDataRelevantAll,
  fullDataTest,
} from "../../services/ConnectDataBase.js";
import { useSelector, useDispatch } from "react-redux";
import { getArrayInfoDataUpdate } from "../../services/Functions";
import { updateInfoData } from "../../redux/reducers";
import { formatFechaDDMMYYYY } from "../../services/Functions";
import { backgroundColor2 } from "../../constants/Constants.js";

// Configuración de skeletons de carga
const SKELETON_CONFIG = {
  rows: 7,              // Número de filas de skeletons
  columns: 9,           // Número de columnas de datos (sin contar la columna de nombre)
  height: 20,           // Altura de los skeletons en px
  widthLabel: "100%",   // Ancho del skeleton de etiqueta
  widthValue: "100%",   // Ancho del skeleton de valor
};

const InformacionRelevante = ({ navigation, datosRelevantes }) => {
  const screenName = "InformacionRelevante";
  const currentScreenId = SCREEN_IDS.RELEVANT_DATA;
  const [datosMo, setDatosMo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ cliente: "", mos: [] });
  const [showSearchModal, setShowSearchModal] = useState(false);
  const lang = useSelector((state) => state.lang.value);
  const [searchResults, setSearchResults] = useState([]);
  const [detalleTabla, setDetalleTabla] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoriaActual, setCategoriaActual] = useState("");
  const [searchTermDetalle, setSearchTermDetalle] = useState("");
  const [detallePiezasJoya, setDetallePiezasJoya] = useState([]);
  const [detallePiezasJoyaComplete, setDetallePiezasJoyaComplete] = useState(
    []
  );

  const [showDetalle, setShowDetalle] = useState(false);
  const [dataComplete, setDataComplete] = useState([]);
  const [detalleModalVisible, setDetalleModalVisible] = useState(true);

  // Estados para filtros
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [currentFilterColumn, setCurrentFilterColumn] = useState("");
  const [filterOptions, setFilterOptions] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [filterPosition, setFilterPosition] = useState({ x: 0, y: 0 });

  const dispatch = useDispatch();

  useEffect(() => {
    const processData = async () => {
      try {
        setIsLoading(true);

        const dataOk = await fullDataTest(SCREEN_IDS.GENERAL, "infoRelevant");

        if (dataOk) {
          processCompleteDataInBackground(dataOk);

          const todosLosDatos = Object.values(dataOk.datosCompletos || {});

          const soloFornituras = todosLosDatos.filter((item) => {
            const referencia = item.referencia || "";
            const esFornituraItem = esFornitura(referencia);
            const tienePendientes =
              Math.round(item.cantidad_pendiente || 0) > 0;
            return esFornituraItem && tienePendientes;
          });

          const soloPiezas = todosLosDatos.filter((item) => {
            const referencia = item.referencia || "";
            const esPieza = !esFornitura(referencia);
            const tienePendientes =
              Math.round(item.cantidad_pendiente || 0) > 0;
            return esPieza && tienePendientes;
          });


          const todasLasPiezas = [...soloPiezas, ...soloFornituras];

          if (todasLasPiezas.length > 0) {
            const moList = todasLasPiezas.map((item) => item.mo);

            const detalles = await getDetalleDatosMos(
              SCREEN_IDS.GENERAL,
              "DetalleDatosMos",
              moList
            );

            const piezasConDetalles = todasLasPiezas.map((item) => {

              
              const adicional = Array.isArray(detalles)
                ? detalles.find((d) => d.mo === item.mo) || {}
                : {};

              const result = {
                mo: item.mo,
                cliente: adicional?.cliente || "N/A",
                referencia: adicional?.referencia || item.referencia || "N/A",
                aleacion: adicional?.aleacion || "N/A",
                gramos: adicional?.gramos || "N/A",
                cantidad: Math.round(item.cantidad_total || "0"),
                cantidadTerminada: Math.round(item.cantidad_fabricada || "0"),
                cantidadPendiente: Math.round(item.cantidad_pendiente || "0"),
                fechaOrden: adicional?.fechaOrden?.date || "N/A",
                fechaEntrega: item.fechaentrega?.date || "N/A",
                // piedras_engastar: adicional?.piedras_engastar || "N/A",
                tipo_orden: adicional?.tipo_orden || "N/A",
                clasificacioncliente: adicional?.clasificacioncliente || "N/A",
                procesos: adicional?.procesos || [],
                total:
                  Math.round(item.cantidad_pendiente || "0") *
                  (item.tiempo_teorico || 1),
              };

              return result;
            });

            setDetallePiezasJoya(piezasConDetalles);
          }

          const summaries = [
            calculateCategoryData(
              dataOk.numeroPedidos,
              translateText("Pedidos", lang)
            ),
            calculateCategoryData(dataOk.numeroMO, translateText("MOs", lang)),
            calculateSumarPiezas(
              dataOk.piezasSinFundir,
              translateText("Fundición", lang)
            ),
            calculateSumarPiezasPorDias(
              dataOk.reparacionesPendientes,
              translateText("Reparaciones", lang)
            ),

            calculateSumarPiezas(
              soloFornituras,
              translateText("Fornituras", lang) + " (C, F, L, Z)"
            ),

            calculateSumarPiezas(
              soloPiezas,
              translateText("Nº de piezas", lang)
            ),
            calculatePiedrasPendientes(
              dataOk.piedrasPendientes,
              translateText("Nº de Piedras", lang)
            ),
          ];

          setDatosMo(summaries);
          if (typeof datosRelevantes === "function") {
            datosRelevantes(summaries);
          }
        }

        setIsLoading(false);

        processCompleteDataInBackground(dataOk);
      } catch (error) {
        console.error("Error en carga inicial:", error);
        setIsLoading(false);
      }
    };

    const processCompleteDataInBackground = async (dataFromAPI) => {
      try {
        const dataAll = dataFromAPI.datosCompletos || [];

        if (dataAll && Array.isArray(dataAll)) {
          const moListAll = [];
          for (let i = 0; i < dataAll.length; i++) {
            if (dataAll[i] && dataAll[i].mo) {
              moListAll.push(dataAll[i].mo);
            }
          }

          if (moListAll.length > 0) {
            const batchSize = 1000;
            let allDetalles = [];

            for (let i = 0; i < moListAll.length; i += batchSize) {
              const batch = moListAll.slice(i, i + batchSize);
              const batchNumber = Math.floor(i / batchSize) + 1;

              try {
                const detallesBatch = await getDetalleDatosMos(
                  SCREEN_IDS.GENERAL,
                  "DetalleDatosMos",
                  batch
                );

                if (Array.isArray(detallesBatch) && detallesBatch.length > 0) {
                  allDetalles = allDetalles.concat(detallesBatch);
                }
              } catch (error) {
                console.error(
                  `❌ Error en background lote ${batchNumber}:`,
                  error.message
                );
              }

              if (i + batchSize < moListAll.length) {
                await new Promise((resolve) => setTimeout(resolve, 50));
              }
            }

            const detallesArray = Array.isArray(allDetalles) ? allDetalles : [];

            const piezasConDetallesAll = dataAll.map((item) => {
              const adicional =
                detallesArray.find((d) => d?.mo === item.mo) || {};

              const result = {
                mo: item.mo,
                cliente: adicional?.cliente || "N/A",
                referencia: adicional?.referencia || "N/A",
                aleacion: adicional?.aleacion || "N/A",
                gramos: adicional?.gramos || "N/A",
                // piedras_engastar: adicional?.piedras_engastar || "N/A",
                cantidad: Math.round(item.cantidad_total || "0"),
                cantidadTerminada: Math.round(item.cantidad_fabricada || "0"),
                cantidadPendiente: Math.round(item.cantidad_pendiente || "0"),

                fechaOrden: adicional?.fechaOrden?.date || "N/A",
                fechaEntrega: item.fechaentrega?.date || "N/A",
                tipo_orden: adicional?.tipo_orden || "N/A",
                clasificacioncliente: adicional?.clasificacioncliente || "N/A",
                procesos: adicional?.procesos || [],
                total:
                  Math.round(item.cantidad_pendiente || "0") *
                  (item.tiempo_teorico || 1),
              };


              return result;
            });

            // Actualizar datos completos cuando terminen
            setDetallePiezasJoyaComplete(piezasConDetallesAll);
          }
        }
      } catch (error) {
        console.error("Error en procesamiento background:", error);
      }
    };

    processData();
  }, []);

  useEffect(() => {
    const unsubscribe = navigation.addListener("focus", () => {
      if (showDetalle) {
        setDetalleModalVisible(true);
      }
    });
    return unsubscribe;
  }, [navigation, showDetalle]);

  useEffect(() => {
    if (showDetalle) {
      setDetalleModalVisible(true);
    }
  }, [showDetalle]);

  const formatNumber = (value) => {
    if (
      !isNaN(value) &&
      value !== null &&
      value !== undefined &&
      value !== ""
    ) {
      return Math.round(value);
    }
    return value;
  };

  const openDetalleTabla = () => {
    setShowDetalle(true);
  };

  const closeDetalleTabla = () => {
    setShowDetalle(false);
    setDetalleModalVisible(false);
  };

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const calculateCategoryData = (data, categoryName) => {
    const today = new Date();
    const summary = {
      nombreCliente: categoryName,
      total: 0,
      retraso: 0,
      hoy: 0,
      uno: 0,
      cinco: 0,
      quince: 0,
      treinta: 0,
      cuarentaYCinco: 0,
      sesenta: 0,
      faltanDosMeses: 0,
      detalles: {
        retraso: [],
        hoy: [],
        uno: [],
        cinco: [],
        quince: [],
        treinta: [],
        cuarentaYCinco: [],
        faltanDosMeses: [],
      },
    };

    data.forEach((item) => {
      const entrega = new Date(item.fechaentrega.date);
      const diffTime = entrega.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24));
      let cantidad = 1;

      summary.total += Math.round(cantidad);

      if (diffDays < 0) {
        summary.retraso += Math.round(cantidad);
        summary.detalles.retraso.push(item);
      } else if (diffDays === 0) {
        summary.hoy += Math.round(cantidad);
        summary.detalles.hoy.push(item);
      } else if (diffDays === 1) {
        summary.uno += Math.round(cantidad);
        summary.detalles.uno.push(item);
      } else if (diffDays <= 14) {
        summary.cinco += Math.round(cantidad);
        summary.detalles.cinco.push(item);
      } else if (diffDays <= 29) {
        summary.quince += Math.round(cantidad);
        summary.detalles.quince.push(item);
      } else if (diffDays <= 44) {
        summary.treinta += Math.round(cantidad);
        summary.detalles.treinta.push(item);
      } else if (diffDays <= 59) {
        summary.cuarentaYCinco += Math.round(cantidad);
        summary.detalles.cuarentaYCinco.push(item);
      } else if (diffDays > 60) {
        summary.faltanDosMeses += Math.round(cantidad);
        summary.detalles.faltanDosMeses.push(item);
      }
    });

    return summary;
  };

  const calculateSumarPiezas = (data, categoryName) => {

    const today = new Date();
    const summary = {
      nombreCliente: categoryName,
      total: 0,
      retraso: 0,
      hoy: 0,
      uno: 0,
      cinco: 0,
      quince: 0,
      treinta: 0,
      cuarentaYCinco: 0,
      sesenta: 0,
      faltanDosMeses: 0,
      detalles: {
        retraso: [],
        hoy: [],
        uno: [],
        cinco: [],
        quince: [],
        treinta: [],
        cuarentaYCinco: [],
        faltanDosMeses: [],
      },
    };

    data.forEach((item) => {
      const entrega = new Date(item.fechaentrega.date);
      const diffTime = entrega.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24));
      let cantidad = Math.round(
        item.cantidad_pendiente || item.cantidad || "0"
      );

      summary.total += Math.round(cantidad);

      if (diffDays < 0) {
        summary.retraso += Math.round(cantidad);
        summary.detalles.retraso.push(item);
      } else if (diffDays === 0) {
        summary.hoy += Math.round(cantidad);
        summary.detalles.hoy.push(item);
      } else if (diffDays === 1) {
        summary.uno += Math.round(cantidad);
        summary.detalles.uno.push(item);
      } else if (diffDays >= 2 && diffDays <= 5) {
        summary.cinco += Math.round(cantidad);
        summary.detalles.cinco.push(item);
      } else if (diffDays >= 6 && diffDays <= 15) {
        summary.quince += Math.round(cantidad);
        summary.detalles.quince.push(item);
      } else if (diffDays >= 16 && diffDays <= 30) {
        summary.treinta += Math.round(cantidad);
        summary.detalles.treinta.push(item);
      } else if (diffDays >= 31 && diffDays <= 45) {
        summary.cuarentaYCinco += Math.round(cantidad);
        summary.detalles.cuarentaYCinco.push(item);
      } else if (diffDays >= 46) {
        summary.faltanDosMeses += Math.round(cantidad);
        summary.detalles.faltanDosMeses.push(item);
      }
    });

    return summary;
  };

  const calculateSumarPiezasPorDias = (data, categoryName) => {
    const today = new Date();
    const summary = {
      nombreCliente: categoryName,
      total: 0,
      retraso: 0,
      hoy: 0,
      uno: 0,
      cinco: 0,
      quince: 0,
      detalles: {
        retraso: [],
        hoy: [],
        uno: [],
        cinco: [],
        quince: [],
      },
    };

    data.forEach((item) => {
      const entrega = new Date(item.fechaentrega.date);
      const diffTime = entrega.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24));
      let cantidad = Math.round(item.cantidad);

      summary.total += Math.round(cantidad);

      if (diffDays < 0) {
        summary.retraso += Math.round(cantidad);
        summary.detalles.retraso.push(item);
      } else if (diffDays === 0) {
        summary.hoy += Math.round(cantidad);
        summary.detalles.hoy.push(item);
      } else if (diffDays === 1) {
        summary.uno += Math.round(cantidad);
        summary.detalles.uno.push(item);
      } else if (diffDays > 1 && diffDays < 6) {
        summary.cinco += Math.round(cantidad);
        summary.detalles.cinco.push(item);
      } else if (diffDays >= 6) {
        summary.quince += Math.round(cantidad);
        summary.detalles.quince.push(item);
      }
    });

    summary.total =
      summary.retraso +
      summary.hoy +
      summary.uno +
      summary.cinco +
      summary.quince;
    return summary;
  };

  const validateData = async (code) => {
    if (!code) {
      return;
    }
    try {
      const dataOk = await fullDataPiece(code.mo, 2);
      if (dataOk) {
        const infoData = getArrayInfoDataUpdate(dataOk);
        dispatch(updateInfoData(infoData));
        return dataOk;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmitCode = async (code) => {
    try {
      const fullData = await validateData(code);
      if (code) {
        if (fullData && fullData.mo) {
          navigation.navigate("Info", { data: fullData, fromDetalle: true });
          setDetalleModalVisible(false);
          setShowModal(false);
        } else {
          setDetalleModalVisible(true);
          console.log("La propiedad 'mo' no existe en fullData.");
        }
      }
    } catch (error) {
      setDetalleModalVisible(true);
      console.error(error);
    }
  };

  const calculatePiedrasPendientes = (data, categoryName) => {
    const today = new Date();
    const summary = {
      nombreCliente: categoryName,
      total: 0,
      retraso: 0,
      hoy: 0,
      uno: 0,
      cinco: 0,
      quince: 0,
      treinta: 0,
      cuarentaYCinco: 0,
      sesenta: 0,
      faltanDosMeses: 0,
      detalles: {
        retraso: [],
        hoy: [],
        uno: [],
        cinco: [],
        quince: [],
        treinta: [],
        cuarentaYCinco: [],
        faltanDosMeses: [],
      },
    };

    data.forEach((item) => {
      const entrega = new Date(item.fechaentrega.date);
      const diffTime = entrega.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24));

      const cantidad = Math.round(
        item.cantidad_pendiente * item.tiempo_teorico
      );

      summary.total += Math.round(cantidad);

      if (diffDays < 0) {
        summary.retraso += Math.round(cantidad);
        summary.detalles.retraso.push(item);
      } else if (diffDays === 0) {
        summary.hoy += Math.round(cantidad);
        summary.detalles.hoy.push(item);
      } else if (diffDays === 1) {
        summary.uno += Math.round(cantidad);
        summary.detalles.uno.push(item);
      } else if (diffDays >= 2 && diffDays <= 5) {
        summary.cinco += Math.round(cantidad);
        summary.detalles.cinco.push(item);
      } else if (diffDays >= 6 && diffDays <= 15) {
        summary.quince += Math.round(cantidad);
        summary.detalles.quince.push(item);
      } else if (diffDays >= 16 && diffDays <= 30) {
        summary.treinta += Math.round(cantidad);
        summary.detalles.treinta.push(item);
      } else if (diffDays >= 31 && diffDays <= 45) {
        summary.cuarentaYCinco += Math.round(cantidad);
        summary.detalles.cuarentaYCinco.push(item);
      } else if (diffDays >= 46) {
        summary.faltanDosMeses += Math.round(cantidad);
        summary.detalles.faltanDosMeses.push(item);
      }
    });

    return summary;
  };

  const filteredMos = modalData.mos.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.mo?.toLowerCase().includes(term) ||
      String(item.po)?.toLowerCase().includes(term) ||
      item.nombreCliente?.toLowerCase().includes(term) ||
      item.cantidad?.toString().toLowerCase().includes(term)
    );
  });

  const extractClientName = (imagenStamping) => {
    if (!imagenStamping) return null;
    const withoutExtension = imagenStamping.split(".")[0];
    return withoutExtension;
  };

  // Funciones para manejar filtros
  const getColumnKey = (headerText) => {
    const columnMap = {
      [translateText("MO", lang)]: "mo",
      [translateText("Referencia", lang)]: "referencia",
      [translateText("Fecha Orden", lang)]: "fechaOrden",
      [translateText("Fecha de Entrega", lang)]: "fechaEntrega",
      [translateText("Cant. piezas", lang)]: "cantidad",
      [translateText("Cant. piezas Pendientes", lang)]: "cantidadPendiente",
      [translateText("Cliente", lang)]: "cliente",
      [translateText("Tipo orden", lang)]: "tipo_orden",
      [translateText("Categoría", lang)]: "clasificacioncliente",
      [translateText("Total Piedras", lang)]: "total"
    };
    return columnMap[headerText] || headerText.toLowerCase();
  };

  const handleFilterClick = (headerText, event) => {
    console.log("Filter click triggered for:", headerText);
    
    const columnKey = getColumnKey(headerText);
    setCurrentFilterColumn(columnKey);
    
    // Función para formatear fechas
    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      
      try {
        // Si es una fecha con timestamp, extraer solo la parte de la fecha
        const dateOnly = dateString.split(' ')[0];
        const date = new Date(dateOnly);
        
        // Verificar si es una fecha válida
        if (isNaN(date.getTime())) {
          return dateString.toString();
        }
        
        // Formatear a DD-MM-YYYY
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
      } catch (error) {
        return dateString.toString();
      }
    };
    
    // Obtener valores únicos para esta columna
    let uniqueValues = [...new Set(
      detalleTabla.map(item => {
        const value = item[columnKey];
        
        // Si es una columna de fecha, formatear la fecha
        if (columnKey === 'fechaOrden' || columnKey === 'fechaEntrega') {
          return formatDate(value);
        }
        
        // Si es una columna numérica, quitar ceros decimales innecesarios
        if (columnKey === 'cantidad' || columnKey === 'cantidadPendiente' || columnKey === 'total') {
          if (value && !isNaN(parseFloat(value))) {
            const num = parseFloat(value);
            return Number.isInteger(num) ? num.toString() : num.toString();
          }
        }
        
        return value ? value.toString() : "N/A";
      })
    )];

    // Ordenar fechas cronológicamente si es una columna de fecha
    if (columnKey === 'fechaOrden' || columnKey === 'fechaEntrega') {
      uniqueValues = uniqueValues.sort((a, b) => {
        // Si es "N/A", ponerlo al final
        if (a === "N/A") return 1;
        if (b === "N/A") return -1;
        
        // Convertir DD-MM-YYYY a Date para comparar
        const dateA = new Date(a.split('-').reverse().join('-'));
        const dateB = new Date(b.split('-').reverse().join('-'));
        
        return dateA - dateB; // Orden ascendente (más antigua primero)
      });
    } else {
      // Para otras columnas, ordenar alfabéticamente
      uniqueValues = uniqueValues.sort();
    }
    
    setFilterOptions(uniqueValues);
    setFilterSearchTerm("");
    
    // Calcular posición del desplegable
    if (event && event.target) {
      const rect = event.target.getBoundingClientRect();
      setFilterPosition({
        x: rect.left,
        y: rect.bottom + 5
      });
    } else {
      // Posición por defecto si no se puede obtener la posición
      setFilterPosition({
        x: window.innerWidth / 2 - 200,
        y: 200
      });
    }
    
    setShowFilterModal(true);
  };

  const handleFilterToggle = (option) => {
    const currentSelection = selectedFilters[currentFilterColumn] || [];
    const newSelection = currentSelection.includes(option)
      ? currentSelection.filter(item => item !== option)
      : [...currentSelection, option];
    
    setSelectedFilters(prev => ({
      ...prev,
      [currentFilterColumn]: newSelection
    }));
  };

  const handleSelectAll = () => {
    setSelectedFilters(prev => ({
      ...prev,
      [currentFilterColumn]: filterOptions
    }));
  };

  const handleSelectNone = () => {
    setSelectedFilters(prev => ({
      ...prev,
      [currentFilterColumn]: []
    }));
  };

  const getFilteredData = () => {
    if (Object.keys(selectedFilters).length === 0) {
      return detalleTabla;
    }

    // Función para formatear fechas (misma que en handleFilterClick)
    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      
      try {
        // Si es una fecha con timestamp, extraer solo la parte de la fecha
        const dateOnly = dateString.split(' ')[0];
        const date = new Date(dateOnly);
        
        // Verificar si es una fecha válida
        if (isNaN(date.getTime())) {
          return dateString.toString();
        }
        
        // Formatear a DD-MM-YYYY
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
      } catch (error) {
        return dateString.toString();
      }
    };

    return detalleTabla.filter(item => {
      return Object.entries(selectedFilters).every(([column, values]) => {
        if (values.length === 0) return true;
        
        let itemValue;
        // Si es una columna de fecha, formatear la fecha
        if (column === 'fechaOrden' || column === 'fechaEntrega') {
          itemValue = formatDate(item[column]);
        } 
        // Si es una columna numérica, quitar ceros decimales innecesarios
        else if (column === 'cantidad' || column === 'cantidadPendiente' || column === 'total') {
          if (item[column] && !isNaN(parseFloat(item[column]))) {
            const num = parseFloat(item[column]);
            itemValue = Number.isInteger(num) ? num.toString() : num.toString();
          } else {
            itemValue = "N/A";
          }
        } else {
          itemValue = item[column] ? item[column].toString() : "N/A";
        }
        
        return values.includes(itemValue);
      });
    });
  };

  const getFilteredOptions = () => {
    if (!filterSearchTerm) return filterOptions;
    return filterOptions.filter(option => 
      option.toLowerCase().includes(filterSearchTerm.toLowerCase())
    );
  };

  const clearAllFilters = () => {
    setSelectedFilters({});
  };

  const handleCellPress = async (cliente, column, detalles) => {
    setCategoriaActual(cliente);
    const mosSeleccionadas = detalles[column].map((item) =>
      cliente === "Pedidos" || cliente === "Fundición" ? item.po : item.mo
    );

    try {
      const datosAdicionales = await getDetalleDatosMos(
        SCREEN_IDS.GENERAL,
        "DetalleDatosMos",
        mosSeleccionadas
      );

      const datosConNombre = detalles[column].map((item) => {
        const adicional = Array.isArray(datosAdicionales)
          ? datosAdicionales.find((d) =>
              cliente === "Pedidos" || cliente === "Fundición"
                ? d.po === item.po
                : d.mo === item.mo
            )
          : {};        

        return {
          mo:
            cliente === "Pedidos" || cliente === "Fundición"
              ? item.po
              : item.mo,
          cliente: extractClientName(adicional?.cliente) || extractClientName(item.imagen_stamping) || "N/A",
          fechaEntrega: item.fechaentrega?.date || "N/A",
          cantidad: adicional?.cantidad_total || adicional?.cantidad || item.cantidad_total || "N/A",
          cantidadPendiente: adicional?.cantidad_pendiente || item.cantidad_pendiente || "N/A",
          referencia: adicional?.referencia || item.referencia || "N/A",
          clasificacioncliente: adicional?.clasificacioncliente || "N/A",
          fechaOrden:
            adicional?.fechaOrden && !isNaN(new Date(adicional.fechaOrden.date))
              ? new Date(adicional.fechaOrden.date).toISOString().split("T")[0]
              : "N/A",
          tipo_orden: adicional?.tipo_orden || "N/A",
          total: adicional?.cantidad_pendiente * item?.tiempo_teorico || item?.cantidad_total || null,
        };
      });

      setDetalleTabla(datosConNombre);
      openDetalleTabla();
    } catch (error) {
      console.error("Error obteniendo datos adicionales para las MOs:", error);
    }
  };


  const getCellStyle = (value, column) => {
    let backgroundColor, color, fontWeight;
    if (value === 0) {
      return {
        backgroundColor: "transparent",
        color: TEXT_COLORS.TERTIARY,
        fontWeight: "normal",
      };
    }
    if (value > 0) {
      switch (column) {
        case "retraso":
          backgroundColor = BRAND_COLORS.ACCENT;
          color = TEXT_COLORS.LIGHT;
          fontWeight = "500";
          break;
        case "hoy":
          backgroundColor = "#4a7c8a";
          color = TEXT_COLORS.LIGHT;
          fontWeight = "500";
          break;
        case "uno":
          backgroundColor = "#5a8c9a";
          color = TEXT_COLORS.LIGHT;
          fontWeight = "500";
          break;
        case "cinco":
        case "dos":
          backgroundColor = "#7aa5b3";
          color = TEXT_COLORS.LIGHT;
          fontWeight = "500";
          break;
        case "quince":
        case "tres":
          backgroundColor = "#9bb1bb";
          color = TEXT_COLORS.DARK;
          fontWeight = "500";
          break;
        case "treinta":
        case "cuatro":
          backgroundColor = "#c1d1d8";
          color = TEXT_COLORS.DARK;
          fontWeight = "500";
          break;
        case "cuarentaYCinco":
        case "cinco":
          backgroundColor = "#dee3e5";
          color = TEXT_COLORS.DARK;
          fontWeight = "500";
          break;
        case "faltanDosMeses":
        case "seis":
          backgroundColor = "#e8edef";
          color = TEXT_COLORS.DARK;
          fontWeight = "500";
          break;
        default:
          backgroundColor = "transparent";
          color = TEXT_COLORS.DARK;
          fontWeight = "normal";
      }
    } else {
      backgroundColor = "transparent";
      color = TEXT_COLORS.DARK;
      fontWeight = "normal";
    }
    return { backgroundColor, color, fontWeight };
  };

  return (
    <View style={styles.containerRepairScreen}>
      <View style={styles.tableRepairScreen}>
        {/* Nota informativa */}
        <View
          style={{
            position: "absolute",
            top: -20,
            left: "30%",
            right: "30%",
            borderRadius: 4,
            paddingHorizontal: 8,
            paddingVertical: 2,
            alignSelf: "center",
          }}>
          <Text
            style={{
              fontFamily: "monospace",
              textAlign: "center",
              fontSize: 14,
              fontWeight: "normal",
              color: backgroundColor2,
            }}>
            {translateText("* Días hasta fecha de entrega", lang)}
          </Text>
        </View>

        <TableContainer
          component={Paper}
          style={{
            ...styles.tableContainerRepairScreen,
            maxHeight: "75vh",
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
          }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {/* Columna principal */}
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BRAND_COLORS.ACCENT,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "6px 12px",
                    borderTopLeftRadius: 4,
                  }}>
                  <Text
                    style={{
                      fontWeight: "500",
                      color: "white",
                      fontSize: 14,
                      letterSpacing: 0.2,
                    }}>
                    {translateText("Unidades Pendientes", lang)}
                  </Text>
                </TableCell>

                {/* Headers */}
                {datosMo.some(
                  (item) => item.nombreCliente === "Pendientes de reparar"
                ) && datosMo.length === 1
                  ? [
                      { text: "1", bg: BRAND_COLORS.ACCENT },
                      { text: "2", bg: BRAND_COLORS.ACCENT },
                      { text: "3", bg: BRAND_COLORS.ACCENT },
                      { text: "4", bg: BRAND_COLORS.ACCENT },
                      { text: "5", bg: BRAND_COLORS.ACCENT },
                      { text: "6", bg: BRAND_COLORS.ACCENT },
                      {
                        text: translateText("Total", lang),
                        bg: BRAND_COLORS.PRIMARY,
                        isTotal: true,
                      },
                    ].map((header, index) => (
                      <TableCell
                        key={index}
                        style={{
                          ...styles.headerCellRepairScreen,
                          backgroundColor: header.bg,
                          borderBottom: `1px solid rgba(255,255,255,0.1)`,
                          padding: "6px 4px",
                          textAlign: "center",
                          minWidth: header.isTotal ? 65 : 50,
                          borderTopRightRadius: index === 6 ? 4 : 0,
                        }}>
                        <Text
                          style={{
                            fontWeight: header.isTotal ? "600" : "500",
                            color: "white",
                            fontSize: 13,
                            letterSpacing: 0.1,
                          }}>
                          {header.text}
                        </Text>
                      </TableCell>
                    ))
                  : [
                      {
                        text: translateText("En retraso", lang),
                        bg: BRAND_COLORS.ACCENT,
                      },
                      {
                        text: translateText("Hoy", lang),
                        bg: BRAND_COLORS.ACCENT,
                      },
                      { text: "1", bg: BRAND_COLORS.ACCENT },
                      { text: "2 - 5", bg: BRAND_COLORS.ACCENT },
                      { text: "6 - 15", bg: BRAND_COLORS.ACCENT },
                      { text: "16 - 30", bg: BRAND_COLORS.ACCENT },
                      { text: "31 - 45", bg: BRAND_COLORS.ACCENT },
                      { text: ">= 46", bg: BRAND_COLORS.ACCENT },
                      {
                        text: translateText("Total", lang),
                        bg: BRAND_COLORS.PRIMARY,
                        isTotal: true,
                      },
                    ].map((header, index) => (
                      <TableCell
                        key={index}
                        style={{
                          ...styles.headerCellRepairScreen,
                          backgroundColor: header.bg,
                          borderBottom: `1px solid rgba(255,255,255,0.1)`,
                          padding: "6px 4px",
                          textAlign: "center",
                          minWidth: header.isTotal ? 70 : 55,
                          borderTopRightRadius: index === 8 ? 4 : 0,
                        }}>
                        <Text
                          style={{
                            fontWeight: header.isTotal ? "600" : "500",
                            color: "white",
                            fontSize: 13,
                            letterSpacing: 0.1,
                          }}>
                          {header.text}
                        </Text>
                      </TableCell>
                    ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {isLoading ? (
                <>
                  {[...Array(SKELETON_CONFIG.rows)].map((_, i) => (
                    <TableRow
                      key={i}
                      style={{
                        backgroundColor: i % 2 === 0 ? "#ffffff" : "#f5f5f5",
                      }}>
                      {/* Columna de nombre de categoría */}
                      <TableCell
                        style={{
                          padding: "4px 8px",
                          backgroundColor: "#ffffff",
                        }}>
                        <Skeleton variant="text" width={SKELETON_CONFIG.widthLabel} height={SKELETON_CONFIG.height} />
                      </TableCell>
                      {/* Columnas de datos */}
                      {[...Array(SKELETON_CONFIG.columns)].map((_, j) => (
                        <TableCell
                          key={j}
                          style={{
                            padding: "4px 8px",
                            textAlign: "center",
                          }}>
                          <Skeleton variant="text" width={SKELETON_CONFIG.widthValue} height={SKELETON_CONFIG.height} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </>
              ) : (
                datosMo.map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      ...styles.rowRepairScreen,
                      backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                      "&:hover": { backgroundColor: BACKGROUND_COLORS.SECONDARY },
                    }}>
                    {/* Nombre de categoría */}
                    <TableCell
                      style={{
                        ...styles.cellRepairScreen,
                        padding: "4px 8px",
                        backgroundColor: "#ffffff",
                      }}>
                      <Text
                        style={{
                          fontWeight: "600",
                          color: "#174045",
                          fontSize: 13,
                        }}>
                        {item.nombreCliente === "Pendientes de reparar"
                          ? "Pendientes de reparar (6 días)"
                          : item.nombreCliente || "-"}
                      </Text>
                    </TableCell>

                    {/* Celdas de datos */}
                    {item.nombreCliente === "Pendientes de reparar" &&
                    datosMo.length === 1
                      ? ["uno", "dos", "tres", "cuatro", "cinco", "seis"].map(
                          (column) => (
                            <TableCell
                              key={column}
                              style={{
                                ...styles.cellRepairScreen,
                                padding: "2px 4px",
                                textAlign: "center",
                                backgroundColor: getCellStyle(
                                  item[column],
                                  column
                                ).backgroundColor,
                              }}>
                            <TouchableOpacity
                              onPress={() =>
                                handleCellPress(
                                  item.nombreCliente,
                                  column,
                                  item.detalles
                                )
                              }
                              style={{
                                paddingVertical: 2,
                                paddingHorizontal: 4,
                                minWidth: 30,
                                alignItems: "center",
                                flex: 1,
                              }}>
                              <Text
                                style={{
                                  color: getCellStyle(item[column], column)
                                    .color,
                                  fontWeight: getCellStyle(
                                    item[column],
                                    column
                                  ).fontWeight,
                                  fontSize: 13,
                                }}>
                                {item[column] ?? 0}
                              </Text>
                            </TouchableOpacity>
                            </TableCell>
                          )
                        )
                      : [
                          "retraso",
                          "hoy",
                          "uno",
                          "cinco",
                          "quince",
                          "treinta",
                          "cuarentaYCinco",
                          "faltanDosMeses",
                        ].map((column) => (
                          <TableCell
                            key={column}
                            style={{
                              ...styles.cellRepairScreen,
                              padding: "2px 4px",
                              textAlign: "center",
                              backgroundColor: getCellStyle(
                                item[column],
                                column
                              ).backgroundColor,
                            }}>
                            <TouchableOpacity
                              onPress={() =>
                                handleCellPress(
                                  item.nombreCliente,
                                  column,
                                  item.detalles
                                )
                              }
                              style={{
                                paddingVertical: 2,
                                paddingHorizontal: 4,
                                minWidth: 30,
                                alignItems: "center",
                                flex: 1,
                              }}>
                              <Text
                                style={{
                                  color: getCellStyle(item[column], column)
                                    .color,
                                  fontWeight: getCellStyle(item[column], column)
                                    .fontWeight,
                                  fontSize: 13,
                                }}>
                                {item[column] ?? 0}
                              </Text>
                            </TouchableOpacity>
                          </TableCell>
                        ))}

                    <TableCell
                      style={{
                        ...styles.cellRepairScreen,
                        padding: "2px 4px",
                        textAlign: "center",
                        backgroundColor: BRAND_COLORS.PRIMARY,
                      }}>
                      <Text
                        style={{
                          color: "white",
                          fontWeight: "600",
                          fontSize: 13,
                          paddingVertical: 2,
                        }}>
                        {item.total}
                      </Text>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Modal de detalle */}
        {detalleTabla.length > 0 && showDetalle && (
          <Modal
            transparent={true}
            animationType='fade'
            visible={showDetalle && detalleModalVisible}
            onRequestClose={closeDetalleTabla}>
            <View
              style={{
                flex: 1,
                backgroundColor: BACKGROUND_COLORS.PRIMARY,
              }}>
              <View
                style={{
                  backgroundColor: backgroundColor2,
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                  flexDirection: "row",
                  alignItems: "center",
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                }}>
                <TouchableOpacity
                  onPress={closeDetalleTabla}
                  style={{
                    backgroundColor: "rgba(255,255,255,0.1)",
                    borderRadius: 4,
                    padding: 6,
                    marginRight: 12,
                  }}>
                  <ArrowBack style={{ fontSize: 22, color: "white" }} />
                </TouchableOpacity>
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: "normal",
                    color: "white",
                    flex: 1,
                  }}>
                  {translateText("Detalle de", lang)} {categoriaActual}
                </Text>
              </View>

               <View
                 style={{
                   backgroundColor: BACKGROUND_COLORS.PRIMARY,
                   paddingHorizontal: 16,
                   paddingVertical: 10,
                 }}>
                 <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
                   <TextInput
                     style={{
                       flex: 1,
                       backgroundColor: "white",
                       padding: 10,
                       borderRadius: 6,
                       borderWidth: 1,
                       borderColor: BORDER_COLORS.MEDIUM,
                       fontSize: 15,
                       color: TEXT_COLORS.PRIMARY,
                     }}
                     placeholder={translateText("Buscar en detalle", lang)}
                     placeholderTextColor={TEXT_COLORS.TERTIARY}
                     value={searchTermDetalle}
                     onChangeText={setSearchTermDetalle}
                   />
                   {Object.keys(selectedFilters).length > 0 && (
                     <TouchableOpacity
                       style={{
                         backgroundColor: "#ff5722",
                         paddingHorizontal: 12,
                         paddingVertical: 10,
                         borderRadius: 6,
                         flexDirection: "row",
                         alignItems: "center",
                         gap: 4,
                       }}
                       onPress={clearAllFilters}>
                       <Text style={{ color: "white", fontSize: 12, fontWeight: "500" }}>
                         🔍
                       </Text>
                       <Text style={{ color: "white", fontSize: 12, fontWeight: "500" }}>
                         {Object.keys(selectedFilters).length}
                       </Text>
                     </TouchableOpacity>
                   )}
                 </View>
               </View>

              <TableContainer
                component={Paper}
                style={{
                  width: 'calc(100% - 24px)',
                  margin: 12,
                  marginRight: 24,
                  borderRadius: 6,
                  boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
                  maxHeight: 'calc(100vh - 200px)',
                  overflow: 'auto',
                }}>
                <Table stickyHeader size='small'>
                  <TableHead>
                    <TableRow>
                      {[
                        translateText("MO", lang),
                        translateText("Referencia", lang),
                        translateText("Fecha Orden", lang),
                        translateText("Fecha de Entrega", lang),
                        translateText("Cant. piezas", lang),
                        translateText("Cant. piezas Pendientes", lang),
                        translateText("Cliente", lang),
                        translateText("Tipo orden", lang),
                        translateText("Categoría", lang),
                      ].map((header, index) => (
                        <TableCell
                          key={index}
                          style={{
                            backgroundColor: backgroundColor2,
                            color: TEXT_COLORS.LIGHT,
                            fontWeight: "normal",
                            padding: "6px 8px",
                            fontSize: "14px",
                            textAlign: "center",
                            cursor: "pointer",
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                          }}
                          onClick={(e) => handleFilterClick(header, e)}>
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                          }}>
                            <span style={{ color: TEXT_COLORS.LIGHT, marginRight: 4 }}>
                              {header}
                            </span>
                            <span style={{ 
                              color: selectedFilters[getColumnKey(header)]?.length > 0 ? "#ffeb3b" : TEXT_COLORS.LIGHT, 
                              fontSize: "12px" 
                            }}>
                              {selectedFilters[getColumnKey(header)]?.length > 0 ? "🔍" : "▼"}
                            </span>
                          </div>
                        </TableCell>
                      ))}
                      {categoriaActual ===
                        translateText("Nº de Piedras", lang) && (
                        <TableCell
                          style={{
                            backgroundColor: backgroundColor2,
                            color: TEXT_COLORS.LIGHT,
                            fontWeight: "normal",
                            padding: "6px 8px",
                            fontSize: "14px",
                            textAlign: "center",
                            cursor: "pointer",
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                          }}
                          onClick={(e) => handleFilterClick(translateText("Total Piedras", lang), e)}>
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                          }}>
                            <span style={{ color: TEXT_COLORS.LIGHT, marginRight: 4 }}>
                              {translateText("Total Piedras", lang)}
                            </span>
                            <span style={{ 
                              color: selectedFilters[getColumnKey(translateText("Total Piedras", lang))]?.length > 0 ? "#ffeb3b" : TEXT_COLORS.LIGHT, 
                              fontSize: "12px" 
                            }}>
                              {selectedFilters[getColumnKey(translateText("Total Piedras", lang))]?.length > 0 ? "🔍" : "▼"}
                            </span>
                          </div>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {getFilteredData()
                      .filter((detalle) => {
                        const searchableValues = [
                          detalle.mo,
                          detalle.cliente,
                          detalle.fechaEntrega,
                          detalle.cantidad,
                          detalle.cantidadPendiente,
                          detalle.referencia,
                          detalle.stamping,
                          detalle.tipo_orden,
                          detalle.clasificacioncliente,
                          detalle.fechaOrden,
                          detalle.total,
                        ]
                          .map((val) =>
                            val ? val.toString().toLowerCase() : ""
                          )
                          .join(" ");
                        return searchableValues.includes(
                          searchTermDetalle.toLowerCase()
                        );
                      })
                      .map((detalle, idx) => (
                        <TableRow
                          key={idx}
                          style={{
                            backgroundColor:
                              idx % 2 === 0 ? BACKGROUND_COLORS.TERTIARY : BACKGROUND_COLORS.CARD,
                            "&:hover": { backgroundColor: BACKGROUND_COLORS.SECONDARY },
                          }}>
                          <TableCell
                            style={{ padding: "4px 6px", textAlign: "center" }}>
                            <TouchableOpacity
                              onPress={() => handleSubmitCode(detalle)}>
                              <Text
                                style={{
                                  fontSize: 14,
                                  // fontWeight: "600",
                                  color: backgroundColor2,
                                  textAlign: "center",
                                }}>
                                {detalle.mo || detalle.po || "N/A"}
                              </Text>
                            </TouchableOpacity>
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                            }}>
                            {detalle.referencia}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                            }}>
                            {detalle.fechaOrden
                              ? formatFechaDDMMYYYY(detalle.fechaOrden)
                              : "N/A"}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                            }}>
                            {detalle.fechaEntrega
                              ? formatFechaDDMMYYYY(detalle.fechaEntrega)
                              : "N/A"}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                              fontFamily: "monospace",
                            }}>
                            {formatNumber(detalle.cantidad)}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                              fontFamily: "monospace",
                            }}>
                            {formatNumber(detalle.cantidadPendiente)}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                            }}>
                            {detalle.cliente
                              ? toTitleCase(detalle.cliente)
                              : ""}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                            }}>
                            {detalle.tipo_orden
                              ? toTitleCase(detalle.tipo_orden)
                              : ""}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "4px 6px",
                              textAlign: "center",
                              fontSize: "14px",
                            }}>
                            {detalle.clasificacioncliente || "N/A"}
                          </TableCell>
                          {categoriaActual ===
                            translateText("Nº de Piedras", lang) && (
                            <TableCell
                              style={{
                                padding: "4px 6px",
                                textAlign: "center",
                                fontSize: "14px",
                                fontFamily: "monospace",
                              }}>
                              {formatNumber(detalle.total)}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}

                    {/* Fila de totales */}
                    <TableRow style={{ backgroundColor: TABLE_COLORS.ROW_TOTAL }}>
                      <TableCell
                        colSpan={4}
                        style={{
                          padding: "6px",
                          fontWeight: "normal",
                          textAlign: "right",
                          fontSize: "14px",
                        }}>
                        {translateText("Totales:", lang)}
                      </TableCell>
                      <TableCell
                        style={{
                          textAlign: "center",
                          fontWeight: "normal",
                          fontFamily: "monospace",
                          fontSize: "14px",
                        }}>
                        {formatNumber(
                          detalleTabla.reduce(
                            (acc, item) => acc + Math.round(item.cantidad || 0),
                            0
                          )
                        )}
                      </TableCell>
                      <TableCell
                        style={{
                          textAlign: "center",
                          fontWeight: "normal",
                          fontFamily: "monospace",
                          fontSize: "14px",
                        }}>
                        {formatNumber(
                          detalleTabla.reduce(
                            (acc, item) =>
                              acc + Math.round(item.cantidadPendiente || 0),
                            0
                          )
                        )}
                      </TableCell>
                      <TableCell colSpan={3} />
                      {categoriaActual ===
                        translateText("Nº de Piedras", lang) && (
                        <TableCell
                          style={{
                            textAlign: "center",
                            fontWeight: "normal",
                            fontFamily: "monospace",
                            fontSize: "14px",
                          }}>
                          {formatNumber(
                            detalleTabla.reduce(
                              (acc, item) => acc + Math.round(item.total || 0),
                              0
                            )
                          )}
                        </TableCell>
                      )}
                    </TableRow>

                    {/* Mensaje sin resultados */}
                    {detalleTabla.filter((detalle) => {
                      const searchableValues = [
                        detalle.mo,
                        detalle.cliente,
                        detalle.fechaEntrega,
                        detalle.cantidad,
                        detalle.cantidadPendiente,
                        detalle.referencia,
                        detalle.stamping,
                        detalle.tipo_orden,
                        detalle.clasificacioncliente,
                        detalle.fechaOrden,
                        detalle.total,
                      ]
                        .map((val) => (val ? val.toString().toLowerCase() : ""))
                        .join(" ");
                      return searchableValues.includes(
                        searchTermDetalle.toLowerCase()
                      );
                    }).length === 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={9}
                          style={{ textAlign: "center", padding: "20px" }}>
                          <Text style={{ fontSize: 15, color: TEXT_COLORS.TERTIARY }}>
                            {translateText(
                              "No se encontraron resultados",
                              lang
                            )}
                          </Text>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </View>
          </Modal>
        )}

        <ConsultaPiezasTabla
          data={detallePiezasJoya}
          dataFull={detallePiezasJoyaComplete}
          isLoading={isLoading}
          onNavigateToMO={handleSubmitCode}
          translateText={translateText}
          lang={lang}
        />
      </View>

      {/* Modal de búsqueda */}
      <Modal
        animationType='fade'
        transparent={true}
        visible={showModal}
        onRequestClose={() => setShowModal(false)}>
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}>
          <View
            style={{
              width: "85%",
              maxWidth: 480,
              maxHeight: "75%",
              backgroundColor: "white",
              borderRadius: 8,
              overflow: "hidden",
              shadowColor: SHADOW_COLORS.PRIMARY,
              shadowOffset: { width: 0, height: 4 },
              shadowOpacity: 0.2,
              shadowRadius: 6,
              elevation: 12,
            }}>
            {/* Header del modal */}
            <View
              style={{
                backgroundColor: backgroundColor2,
                paddingHorizontal: 16,
                paddingVertical: 10,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <Text
                style={{
                  fontSize: 16,
                  fontWeight: "normal",
                  color: TEXT_COLORS.LIGHT,
                }}>
                {modalData.cliente}
              </Text>
              <TouchableOpacity
                onPress={() => setShowModal(false)}
                style={{
                  backgroundColor: "rgba(255,255,255,0.1)",
                  borderRadius: 4,
                  padding: 4,
                }}>
                <Text
                  style={{ color: TEXT_COLORS.LIGHT, fontSize: 16, fontWeight: "normal" }}>
                  ×
                </Text>
              </TouchableOpacity>
            </View>

            {/* Campo de búsqueda */}
            <View style={{ padding: 12 }}>
              <TextInput
                style={{
                  backgroundColor: BACKGROUND_COLORS.PRIMARY,
                  padding: 10,
                  borderRadius: 6,
                  borderWidth: 1,
                  borderColor: BORDER_COLORS.MEDIUM,
                  fontSize: 15,
                  color: TEXT_COLORS.PRIMARY,
                }}
                placeholder={translateText(
                  "Buscar por MO, cliente, cantidad, etc.",
                  lang
                )}
                                  placeholderTextColor={TEXT_COLORS.TERTIARY}
                value={searchTerm}
                onChangeText={setSearchTerm}
              />
            </View>

            {/* Lista de resultados */}
            <ScrollView style={{ flex: 1, paddingHorizontal: 12 }}>
              {modalData.mos.length > 0 ? (
                filteredMos.map((mo, index) => (
                  <TouchableOpacity
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? BACKGROUND_COLORS.TERTIARY : BACKGROUND_COLORS.CARD,
                      borderRadius: 4,
                      marginBottom: 6,
                      paddingVertical: 10,
                      paddingHorizontal: 12,
                      flexDirection: "row",
                      alignItems: "center",
                      borderWidth: 1,
                      borderColor: BORDER_COLORS.LIGHT,
                    }}
                    onPress={() => handleSubmitCode(mo)}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontWeight: "normal",
                        color: TEXT_COLORS.SECONDARY,
                        width: 25,
                      }}>
                      {index + 1}.
                    </Text>
                    <Text
                      style={{
                        flex: 1,
                        fontSize: 15,
                        fontWeight: "normal",
                        color: TEXT_COLORS.PRIMARY,
                        textAlign: "center",
                      }}>
                      {mo.mo || mo.po || "Sin datos"}
                    </Text>
                    <Text style={{ color: TEXT_COLORS.TERTIARY, fontSize: 15 }}>›</Text>
                  </TouchableOpacity>
                ))
              ) : (
                <View style={{ alignItems: "center", paddingVertical: 24 }}>
                  <Text
                    style={{
                      fontSize: 15,
                      color: TEXT_COLORS.TERTIARY,
                      textAlign: "center",
                    }}>
                    {translateText("No se encontraron datos.", lang)}
                  </Text>
                </View>
              )}
            </ScrollView>

            {/* Botón de cierre */}
            <View style={{ padding: 12 }}>
              <TouchableOpacity
                style={{
                  backgroundColor: backgroundColor2,
                  paddingVertical: 10,
                  borderRadius: 6,
                  alignItems: "center",
                }}
                onPress={() => {
                  setShowModal(false);
                  setSearchTerm("");
                  setSearchResults([]);
                }}>
                <Text
                  style={{ color: "white", fontWeight: "normal", fontSize: 15 }}>
                  {translateText("Cerrar", lang)}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Modal de filtros - Renderizado fuera del modal principal */}
      <FilterModal
        visible={showFilterModal}
        onClose={() => setShowFilterModal(false)}
        currentFilterColumn={currentFilterColumn}
        filterOptions={filterOptions}
        selectedFilters={selectedFilters}
        filterSearchTerm={filterSearchTerm}
        setFilterSearchTerm={setFilterSearchTerm}
        handleFilterToggle={handleFilterToggle}
        handleSelectAll={handleSelectAll}
        handleSelectNone={handleSelectNone}
        clearAllFilters={clearAllFilters}
        getFilteredOptions={getFilteredOptions}
        filterPosition={filterPosition}
      />
    </View>
  );
};

// Componente separado para el modal de filtros
const FilterModal = ({ 
  visible, 
  onClose, 
  currentFilterColumn, 
  filterOptions, 
  selectedFilters, 
  filterSearchTerm, 
  setFilterSearchTerm, 
  handleFilterToggle, 
  handleSelectAll, 
  handleSelectNone, 
  clearAllFilters, 
  getFilteredOptions,
  filterPosition
}) => {
  if (!visible) return null;
  
  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
      statusBarTranslucent={true}
      presentationStyle="overFullScreen">
      <TouchableOpacity
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "transparent",
          zIndex: 99999,
          elevation: 99999,
        }}
        activeOpacity={0}
        onPress={onClose}>
        <TouchableOpacity
          style={{
            position: 'absolute',
            left: Math.max(10, Math.min(filterPosition.x, window.innerWidth - 320)),
            top: Math.max(10, filterPosition.y),
            backgroundColor: "white",
            borderRadius: 6,
            padding: 10,
            width: 280,
            maxHeight: 400,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 5,
            borderWidth: 1,
            borderColor: "#9bb1bb",
            opacity: 1,
          }}
          activeOpacity={1}
          onPress={(e) => e.stopPropagation()}>
          {/* Header del modal */}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
              paddingBottom: 8,
              borderBottomWidth: 1,
              borderBottomColor: "#9bb1bb",
            }}>
            <Text
              style={{
                fontSize: 13,
                fontWeight: "600",
                color: "#174045",
                fontFamily: "monospace",
              }}>
              {currentFilterColumn} ({selectedFilters[currentFilterColumn]?.length || 0}/{filterOptions.length})
            </Text>
            <TouchableOpacity
              onPress={onClose}
              style={{
                padding: 2,
              }}>
              <Text style={{ fontSize: 18, color: "#666", fontWeight: "300" }}>×</Text>
            </TouchableOpacity>
          </View>

          {/* Barra de búsqueda */}
          <TextInput
            style={{
              backgroundColor: "#ffffff",
              paddingHorizontal: 8,
              paddingVertical: 6,
              borderRadius: 4,
              borderWidth: 1,
              borderColor: "#9bb1bb",
              fontSize: 12,
              color: "#174045",
              marginBottom: 8,
              fontFamily: "monospace",
              opacity: 1,
            }}
            placeholder={`Buscar en ${currentFilterColumn}...`}
            placeholderTextColor="#999"
            value={filterSearchTerm}
            onChangeText={setFilterSearchTerm}
          />

          {/* Opciones de selección rápida */}
          <View
            style={{
              flexDirection: "row",
              marginBottom: 8,
            }}>
            <TouchableOpacity
              onPress={handleSelectAll}
              style={{
                flex: 1,
                backgroundColor: "#e3f2fd",
                paddingVertical: 5,
                paddingHorizontal: 8,
                borderRadius: 4,
                alignItems: "center",
                marginRight: 4,
              }}>
              <Text style={{ color: "#174045", fontSize: 11, fontWeight: "500", fontFamily: "monospace" }}>
                Todo
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={handleSelectNone}
              style={{
                flex: 1,
                backgroundColor: "#fef2f2",
                paddingVertical: 5,
                paddingHorizontal: 8,
                borderRadius: 4,
                alignItems: "center",
                marginLeft: 4,
              }}>
              <Text style={{ color: "#dc2626", fontSize: 11, fontWeight: "500", fontFamily: "monospace" }}>
                Ninguno
              </Text>
            </TouchableOpacity>
          </View>

          {/* Lista de opciones */}
          <ScrollView
            style={{
              maxHeight: 150,
              marginBottom: 8,
            }}>
            {getFilteredOptions().map((option, index) => (
              <TouchableOpacity
                key={index}
                onPress={() => handleFilterToggle(option)}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingVertical: 6,
                  paddingHorizontal: 8,
                  borderBottomWidth: 1,
                  borderBottomColor: "#9bb1bb",
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                }}>
                <View
                  style={{
                    width: 14,
                    height: 14,
                    borderWidth: 1,
                    borderColor: selectedFilters[currentFilterColumn]?.includes(option) ? "#174045" : "#9bb1bb",
                    borderRadius: 2,
                    marginRight: 8,
                    backgroundColor: selectedFilters[currentFilterColumn]?.includes(option) ? "#174045" : "transparent",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  {selectedFilters[currentFilterColumn]?.includes(option) && (
                    <Text style={{ color: "#ffffff", fontSize: 9, fontWeight: "bold" }}>✓</Text>
                  )}
                </View>
                <Text
                  style={{
                    flex: 1,
                    fontSize: 12,
                    color: "#174045",
                    fontFamily: "monospace",
                  }}>
                  {option}
                </Text>
              </TouchableOpacity>
            ))}
          </ScrollView>

          {/* Botones de acción */}
          <View
            style={{
              flexDirection: "row",
            }}>
            <TouchableOpacity
              onPress={clearAllFilters}
              style={{
                flex: 1,
                backgroundColor: "#dc2626",
                paddingVertical: 6,
                paddingHorizontal: 8,
                borderRadius: 4,
                alignItems: "center",
                marginRight: 4,
              }}>
              <Text style={{ color: "#ffffff", fontSize: 11, fontWeight: "500", fontFamily: "monospace" }}>
                Limpiar todo
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={onClose}
              style={{
                flex: 1,
                backgroundColor: "#174045",
                paddingVertical: 6,
                paddingHorizontal: 8,
                borderRadius: 4,
                alignItems: "center",
                marginLeft: 4,
              }}>
              <Text style={{ color: "#ffffff", fontSize: 11, fontWeight: "500", fontFamily: "monospace" }}>
                Aplicar
              </Text>
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

export default InformacionRelevante;
